import {makeAutoObservable} from "mobx";
import axios from "axios";
import axiosUserInstance from "../../axiosUser";

export default class MessagesInterServicesStore{
    showArchive = false;
    showAdd = false;
    showEdit = false;
    idMessageToDelete = null;
    idCommentToDelete = null;

    constructor() {
        makeAutoObservable(this);
    }

    handleOpenAdd(){
        this.showAdd = true;
    }

    handleCloseAdd(){
        this.showAdd = false;
    }

    handleOpenArchive(){
        this.showArchive = true
    }

    handleCloseArchive(){
        this.showArchive = false
    }

    getCookie(name) {
        let nameEQ = name + "=";
        let ca = document.cookie.split(';');
        for(let i=0;i < ca.length;i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    async getAllTotem(ent)  {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/getAllTotem`,
                { headers: {"Authorization" : `Bearer ${this.getCookie("current_apiToken")}`} }
            );
            return res.data;
        } catch (err) {
            console.log("getAllTotem",err);
            throw new Error("Failed to fetch totems");
        }
    }

    async sendMessagesInterServices(ent, idTotem, data)  {
        try {
            const res = await axios.post(process.env.REACT_APP_API_URL + '/api/MI/AddMessImageFromFront/' + idTotem,
                data,
                {
                    headers: {
                        "Authorization": `Bearer ${this.getCookie("current_apiToken")}`,
                        "Content-Type": "multipart/form-data"
                    }
                });
            return res.data;
        } catch (e) {
            console.log("sendMessagesInterServices", e);
            throw new Error("Failed to send message");
        }
    }

    async sendUpdateMessagesInterServices(ent, idTotem, data, idConf)  {
        try {
            const res = await axios.post(process.env.REACT_APP_API_URL + '/api/MI/UpdateMessImageFromFront/' + idConf +'/'+ idTotem,
                data,
                {
                    headers: {
                        "Authorization": `Bearer ${this.getCookie("current_apiToken")}`,
                        "Content-Type": "multipart/form-data"
                    }
                });
            return res.data;
        } catch (e) {
            console.log("sendUpdateMessagesInterServices", e);
            throw new Error("Failed to update message");
        }
    }

    /// suppr MessagesInterServices
    async deleteMessagesInterServices(ent, idConf) {
        try {
            const res = await axios.delete(process.env.REACT_APP_API_URL + '/api/MI/DeleteMessImageFromFront/' + idConf,
                {
                    headers: {
                        "Authorization": `Bearer ${this.getCookie("current_apiToken")}`
                    }
                });
            return res.data;
        } catch (e) {
            console.log("deleteMessagesInterServices", e);
            throw new Error("Failed to delete message");
        }
    }

    async deleteCommentMessagesInterServices(ent, idComm, idTotem) {
        try {
            const res = await axiosUserInstance.post(process.env.REACT_APP_API_URL + '/api/MI/DeleteComment/' + idComm+'/'+ idTotem,
                {
                    headers: {
                        "Authorization": `Bearer ${this.getCookie("current_apiToken")}`
                    }
                });
            return res.data;
        } catch (e) {
            console.log("deleteMessagesInterServices", e);
            throw new Error("Failed to delete message");
        }
    }
}